import { render, staticRenderFns } from "./AssociationBasicData.vue?vue&type=template&id=cdfde896&"
import script from "./AssociationBasicData.vue?vue&type=script&lang=ts&"
export * from "./AssociationBasicData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports